import { History } from "history";
import { observable } from "mobx";
import React from "react";
import { FormattedMessage } from "react-intl";

import { Auth0, handleError } from "nvent-web/services/Auth0";
import * as logger from "nvent-web/services/logger";
import { NotificationsStore } from "nvent-web/stores/Notifications";

export class LoginFlow {
  @observable email = "";
  @observable password = "";

  readonly locations = {
    forgotPassword: `${this.path}/forgot-password`,
  };

  constructor(
    private auth0: Auth0,
    private history: History,
    private notifications: NotificationsStore,
    private path: string
  ) {}

  startLogin = async (email: string, password: string) => {
    this.email = email;
    this.password = password;

    try {
      await this.auth0.login(email, password);
    } catch (error) {
      return handleError(
        error,
        {
          access_denied: () => this.showError("login.error.incorrectCredentials"),
          invalid_user_password: () => this.showError("login.error.incorrectCredentials"),
        },
        (error) => {
          logger.error(error);
          this.notifications.createGenericError(error, "Login error");
          throw error;
        }
      );
    }
  };

  startPasswordReset = async (email = this.email) => {
    this.email = email;

    try {
      await this.auth0.changePassword(email);
      this.notifications.createSuccess(<FormattedMessage id="login.forgotPassword.success" />);
      this.history.push(this.path);
    } catch (error) {
      logger.error(error);
      this.notifications.createGenericError(error, "Reset error");
      throw error;
    }
  };

  private showError(id: string) {
    this.notifications.createError(<FormattedMessage id={id} />);
  }
}
